import $ from 'jquery'
import Config from 'luminate/src/config'
import Base from 'luminate/src/modules/base'

export default Base.extend({
	directive: 'filter',

	defaults: {
		name: '',
	},

	events: {

		init: function()
		{
			const $filter = $(this.$element)
			const itemAttr = `filter-${this.$settings.name}`
			const $items = $(`[${itemAttr}]`)

			$filter.on('change', () =>
			{
				const filterVal = $filter.val()

				if(filterVal !== 'show-all')
				{
					$items.each(function()
					{
						const $item = $(this)
						const isHidden = $item.hasClass('+hidden')
						const isSelected = $item.attr(itemAttr) === filterVal

						if(isSelected && isHidden)
						{
							$item.removeClass('+hidden')
						}
						else if(!isSelected && !isHidden)
						{
							$item.addClass('+hidden')
						}
					})
				}
				else
				{
					$items.removeClass('+hidden')
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./public/scripts/src/modules/filter.js